import React from 'react';
import check from '../../../assets/svg/check.svg';
import star from '../../../assets/svg/star.svg';
import Button from '../../../components/Buttons/Button';
import { useScreenSize } from '../../../hooks/useScreenSize';

const Certified: React.FC = () => {
  const { isMobile } = useScreenSize();
  return (
    <section className="slide flex-colomn gap-2">
      <div
        className="flex-colomn
      "
      >
        <h2>
          <span className="tertiary-color ">Gecertificeerd </span> koeltechnieker.
        </h2>
        {/* <p className="slide-text">
          Wij werken volgens <span className="bold">vaste kwaliteitsnormen </span> en leveren{' '}
          <span className="bold">installaties die jarenlang meegaan.</span>
        </p> */}
      </div>

      <div className={`${isMobile ? 'flex-colomn' : 'flex-row'} space-between w-100 gap-2`}>
        <div className="flex-row align-end gap-5 p-1">
          <div className="flex-colomn justify-center  gap-2 ">
            <img className="icon-large" src={check} alt="phone icon" />
            <p>1 jaar garantie!</p>
          </div>
          <div className="flex-colomn justify-center  gap-2  ">
            <img className="icon-large" src={star} alt="whatsapp icon" />
            <p>100% tevredenheid!</p>
          </div>
        </div>
        <div className={`${isMobile ? 'flex-colomn' : 'flex-row align-end'}`}>
          <Button to="/installatie-voorbeelden" text="Installatie voorbeelden" />
        </div>
      </div>
    </section>
  );
};

export default Certified;
